import React from 'react';

import classNames from 'classnames/bind';
import style from './ArticlesTales.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

const ArticlesTales = props => {
  const getChunks = arr => {
    let rest = [...arr];
    let chunks = [];

    while (rest.length > 0) {
      let bit = rest.splice(0, 3);
      chunks.push(bit);

      if (rest.length > 0) {
        bit = rest.splice(0, 2);
        chunks.push(bit);
      }
    }

    return chunks;
  };

  const renderArticle = article => {
    return (
      <Link to={article.url} className={ctx('link')}>
        <div
          className={ctx('item')}
          style={{
            backgroundImage: `url(${article.background})`,
          }}
        >
          <div className={ctx('description')}>
            {article.title}
            <div className={ctx('line')} />
          </div>
        </div>
      </Link>
    );
  };

  const { articles } = props;
  const chunks = getChunks(articles);

  return (
    <div className={ctx('tales')}>
      {chunks.map((chunk, key) => {
        return (
          <div className={ctx('row')} key={key}>
            {chunk.map((article, idx) => (
              <div
                className={ctx('col-item')}
                style={{
                  width: `${Math.min(100 / chunk.length, 50)}%`,
                }}
                key={idx}
              >
                {renderArticle(article)}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default ArticlesTales;
